// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ProjectStatusSlug } from '@/constants/project-status';
import { CustomerProjectFiltersContextType } from '@/customer/contexts/customer-project-filters-context.types';
import { CustomerProjectFiltersContext } from '@/customer/hooks/use-customer-project-filters';
import { useState } from 'react';

export function CustomerProjectFiltersProvider(props: {
  children: React.ReactNode;
}) {
  const [locationIds, setLocationIds] = useState<string[]>([]);
  const [productIds, setProductIds] = useState<string[]>([]);
  const [statuses, setStatuses] = useState<ProjectStatusSlug[]>([]);
  const [isArchived, setIsArchived] = useState<boolean>(false);

  const resetFilters = () => {
    setLocationIds([]);
    setProductIds([]);
    setStatuses([]);
    setIsArchived(false);
  };

  const contextValue: CustomerProjectFiltersContextType = {
    locationIds,
    productIds,
    statuses,
    isArchived,
    setLocationIds,
    setProductIds,
    setStatuses,
    setIsArchived,
    resetFilters,
  };

  return (
    <CustomerProjectFiltersContext.Provider value={contextValue}>
      {props.children}
    </CustomerProjectFiltersContext.Provider>
  );
}
